import { fixedAssets } from 'src/containers/PreCache'
import styled from 'styled-components'

export const PageStyle = styled.div`
  overflow-y: scroll;
  background: #000;
  padding-bottom: 100px;

  .header-banner {
    background-image: url(${fixedAssets.top});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 3rem;
  }

  .agenda-grid {
    display: grid;
    grid-auto-rows: max-content;
    position: relative;
    grid-gap: 30px;
  }
  .auditorium-btn {
    color: white;
    border: 1px solid #B4173A;
    background-color: #B4173A;
    display: block;
    margin: auto;
    padding: 8px 18px;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    transition: all 200ms ease-in;
  }
`